import { SocialButton } from 'shared/Pages/common/Login/components/sso-providers/styles';
import { IconGoogle } from 'shared/_ui/icon';
import { SsoButtonProps } from 'shared/Pages/common/Login/components/sso-providers/types';
import {
	getSsoUrlParams,
	ProviderPath,
} from 'shared/Pages/common/Login/components/sso-providers/utils';

export default function GoogleSsoButton({ onSubmitUrl, params, ...rest }: SsoButtonProps) {
	const handleGoogleSso = () => {
		const authUrl = getSsoUrlParams(ProviderPath.GOOGLE, params);
		onSubmitUrl(authUrl);
	};

	return (
		<SocialButton startIcon={<IconGoogle />} onClick={handleGoogleSso} {...rest}>
			Continue with Google
		</SocialButton>
	);
}
